import { css, SerializedStyles, useTheme } from '@core-ui/react-stitch';

const globalStyles = (isBRRedesign: boolean): SerializedStyles => css`
  #custom-landing-page {
    background-color: ${isBRRedesign ? useTheme().color.b2 : 'inherit'};
  };
  #custom-landing-page * {
    box-sizing: border-box;
  };
`;

const getFullWidth: SerializedStyles = css`
  width: 100%;
`;

const getStyles = (isMobileStyle: boolean, isBRRedesign: boolean): SerializedStyles => css`
  display: flex;
  flex-wrap: ${isMobileStyle ? 'wrap' : 'nowrap'};
  flex-direction: ${isMobileStyle ? 'column' : 'row'};
  max-width: ${isBRRedesign ? '1920px' : '1280px'};
  margin: auto;
  padding: ${isBRRedesign ? '0' : '0 0.5rem'};
`;

export {
  globalStyles,
  getFullWidth,
  getStyles
};
